import React from 'react';
import SubCredits from '../../Components/SubCredits';
import AppHeader from '../../Components/Common/Layout/AppHeader';
import { StyledDiv } from '../../Theme/CommonStyled';

const SubCreditPage: React.FC = () => {
  return (
    <>
      <AppHeader title="subCredits" goBack />
      <StyledDiv
        id="notification-container"
        height={'calc(100vh - 60px)'}
        overflow={'auto'}>
        <SubCredits />
      </StyledDiv>
    </>
  );
};

export default SubCreditPage;
